import React, { useState } from "react";
import { submitForm } from "../../lib/api.js";

// fields: [name, label, type] where type is text|email|textarea|select:<a,b,c>
export default function LeadForm({ kind, fields, button = "Send" }) {
  const [v, setV] = useState({});
  const [state, setState] = useState({ status: "idle" });
  const on = (k) => (e) => setV({ ...v, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (v.website) return; // honeypot
    setState({ status: "sending" });
    const r = await submitForm(kind, v);
    setState(r.ok ? { status: "done", fallback: r.fallback } : { status: "error", error: r.error });
  };
  if (state.status === "done")
    return <p className="pg-msg">{state.fallback ? "Opening your email app…" : "Thank you. We'll be in touch shortly."}</p>;
  return (
    <form className="pg-form" onSubmit={submit}>
      {fields.map(([k, label, type = "text", required = true]) => (
        <div key={k}>
          <label htmlFor={`${kind}-${k}`}>{label}</label>
          {type === "textarea" ? (
            <textarea id={`${kind}-${k}`} rows={5} required={required} onChange={on(k)} />
          ) : type.startsWith("select:") ? (
            <select id={`${kind}-${k}`} required={required} defaultValue="" onChange={on(k)}>
              <option value="" disabled>Select…</option>
              {type.slice(7).split(",").map((o) => <option key={o}>{o}</option>)}
            </select>
          ) : (
            <input id={`${kind}-${k}`} type={type} required={required} onChange={on(k)} />
          )}
        </div>
      ))}
      <input type="text" name="website" tabIndex={-1} autoComplete="off" style={{ display: "none" }} onChange={on("website")} />
      <br />
      <button className="pg-btn" type="submit" disabled={state.status === "sending"}>
        {state.status === "sending" ? "Sending…" : button}
      </button>
      {state.status === "error" && <p className="pg-msg err">{state.error}</p>}
    </form>
  );
}
